import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "space-y-6 sm:px-6 lg:col-span-7 lg:px-0" }
const _hoisted_3 = { class: "bg-white shadow-sm sm:rounded-lg" }
const _hoisted_4 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_5 = { class: "sm:inline-flex items-center justify-between w-full" }
const _hoisted_6 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "mt-2 sm:flex sm:items-start sm:justify-between w-full" }
const _hoisted_10 = { class: "w-full text-sm text-gray-500" }
const _hoisted_11 = { class: "w-full bg-gray-200 h-2 rounded" }
const _hoisted_12 = { class: "flex justify-between items-center mt-2" }
const _hoisted_13 = {
  key: 0,
  class: "border-l-4 border-yellow-400 bg-yellow-50 p-4 mt-3"
}
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "shrink-0" }
const _hoisted_16 = { class: "ml-3" }
const _hoisted_17 = { class: "text-sm text-yellow-700" }
const _hoisted_18 = {
  key: 1,
  class: "border-l-4 border-red-400 bg-red-50 p-4 mt-3"
}
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "shrink-0" }
const _hoisted_21 = { class: "ml-3" }
const _hoisted_22 = { class: "text-sm text-red-700" }
const _hoisted_23 = {
  key: 2,
  class: "rounded-md bg-blue-50 p-4 mt-3"
}
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "shrink-0" }
const _hoisted_26 = { class: "ml-3 flex-1 md:flex md:justify-between" }
const _hoisted_27 = { class: "text-sm text-royal-blue-500" }
const _hoisted_28 = { "aria-labelledby": "plan-heading" }
const _hoisted_29 = {
  key: 0,
  class: "border-l-4 border-purple-500 bg-gradient-to-r from-purple-50 to-pink-50 p-4 mb-4 shadow-sm rounded-lg"
}
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "ml-3 flex-1" }
const _hoisted_32 = { class: "text-sm font-bold text-purple-900" }
const _hoisted_33 = { class: "text-sm text-purple-800 mt-1" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_36 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_37 = { class: "md:inline-flex justify-between items-center w-full" }
const _hoisted_38 = {
  id: "plan-heading",
  class: "text-lg/6 font-medium text-gray-900"
}
const _hoisted_39 = { class: "font-medium text-gray-900" }
const _hoisted_40 = { class: "text-gray-500" }
const _hoisted_41 = ["aria-label"]
const _hoisted_42 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6 inline-flex justify-between w-full" }
const _hoisted_43 = { class: "bg-white shadow-sm sm:rounded-lg" }
const _hoisted_44 = { class: "mt-2 sm:flex sm:items-start sm:justify-between" }
const _hoisted_45 = { class: "max-w-xl text-sm text-gray-500" }
const _hoisted_46 = { class: "mt-5 sm:mt-0 sm:ml-6 sm:flex sm:shrink-0 sm:items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_SwitchLabel = _resolveComponent("SwitchLabel")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_SwitchGroup = _resolveComponent("SwitchGroup")!
  const _component_SubscriptionPlanComponent = _resolveComponent("SubscriptionPlanComponent")!
  const _component_RadioGroupOption = _resolveComponent("RadioGroupOption")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardListComponent = _resolveComponent("CardListComponent")!
  const _component_SwitchDescription = _resolveComponent("SwitchDescription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ControlsMenuComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('subscription.title')), 1),
            (_ctx.subscription.key !== 'free')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t('subscription.active_until')) + " ", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.subscribedTo), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                                      'bg-yellow-500': _ctx.storageUsedPercent >= 90 && _ctx.storageUsedPercent < 100,
                                      'bg-red-500': _ctx.storageUsedPercent >= 100,
                                      'bg-blue-600': _ctx.storageUsedPercent < 90
                                    }, "h-full rounded"]),
                  style: _normalizeStyle({ width: `${Math.min(_ctx.storageUsedPercent, 100)}%` })
                }, null, 6)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('subscription.used')) + ":", 1),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.storageUsed), 1),
                  _createTextVNode(" / " + _toDisplayString(_ctx.storageLimit), 1)
                ])
              ])
            ])
          ]),
          (_ctx.storageUsedPercent >= 90 && _ctx.storageUsedPercent < 100)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_ExclamationTriangleIcon, {
                      class: "size-5 text-yellow-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('subscription.storage_warning')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.storageUsedPercent >= 100)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_XCircleIcon, {
                      class: "size-5 text-red-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('subscription.storage_alert')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.subscription.key === 'free')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_InformationCircleIcon, {
                      class: "size-5 text-royal-blue-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('subscription.storage_info')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_28, [
        _createElementVNode("div", null, [
          (_ctx.hasBlackFridayUpgrades)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "shrink-0" }, [
                    _createElementVNode("span", { class: "text-2xl" }, "🛍️")
                  ], -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, " ⚡ " + _toDisplayString(_ctx.$t('subscription.black_friday.banner_title')), 1),
                    _createElementVNode("p", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.black_friday.banner_description')) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.blackFridayTermsUrl,
                        target: "_blank",
                        class: "ml-2 text-sm font-medium text-purple-700 hover:text-purple-900 hover:underline transition-all cursor-pointer"
                      }, _toDisplayString(_ctx.$t('subscription.black_friday.terms_button')), 9, _hoisted_34)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.$t('subscription.change_plan')), 1),
                _createVNode(_component_SwitchGroup, {
                  as: "div",
                  class: "flex items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SwitchLabel, {
                      as: "span",
                      class: "mr-3 text-sm"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('subscription.yearly_subscription')), 1),
                        _cache[4] || (_cache[4] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('subscription.save_up_to')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Switch, {
                      modelValue: _ctx.annualBillingEnabled,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.annualBillingEnabled) = $event)),
                      class: _normalizeClass([_ctx.annualBillingEnabled ? 'bg-royal-blue-500' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-700 focus:ring-offset-2 focus:outline-hidden'])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          "aria-hidden": "true",
                          class: _normalizeClass([_ctx.annualBillingEnabled ? 'translate-x-5' : 'translate-x-0', 'inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("fieldset", {
                "aria-label": _ctx.$t('subscription.plans')
              }, [
                _createVNode(_component_RadioGroup, {
                  modelValue: _ctx.selected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
                  class: "space-y-4"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioGroupOption, {
                        as: "template",
                        key: `subscription-plan-radio-item-${index}-${item.key}`,
                        value: item,
                        "aria-label": item.title,
                        disabled: item.key === 'free',
                        "aria-description": `${item.title}, ${Math.round(item.limit / (1024 * 1024 * 1024) * 100) / 100} ГБ сховища, ${_ctx.getPriceForCurrency(item)} ${_ctx.getCurrencySymbol()} на місяць`
                      }, {
                        default: _withCtx(({ active, checked }) => [
                          _createElementVNode("div", null, [
                            (_openBlock(), _createBlock(_component_SubscriptionPlanComponent, {
                              key: `subscription-plan-item-radio-${index}-${item.key}`,
                              item: item,
                              period: _ctx.period,
                              subscription: _ctx.subscription,
                              selected: _ctx.selected,
                              active: active,
                              checked: checked,
                              "black-friday-upgrade": _ctx.blackFridayUpgrades[item.key]
                            }, null, 8, ["item", "period", "subscription", "selected", "active", "checked", "black-friday-upgrade"]))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "aria-label", "disabled", "aria-description"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 8, _hoisted_41)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: _ctx.subscription.key == _ctx.selected?.key && _ctx.period == 1 ? '#' : `/checkout/${_ctx.selected?.key || ''}?p=${_ctx.period}${_ctx.selected && _ctx.blackFridayUpgrades[_ctx.selected.key] && _ctx.blackFridayUpgrades[_ctx.selected.key].can_upgrade && _ctx.period === 1 ? '&black_friday=true' : ''}`,
                disabled: _ctx.subscription.key == _ctx.selected?.key && _ctx.period == 1,
                class: _normalizeClass({
                                    'ml-auto inline-flex justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs disabled:bg-royal-blue-300 disabled:cursor-not-allowed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900': true,
                                    'bg-royal-blue-500 cursor-pointer hover:bg-royal-blue-600 ': !(_ctx.subscription.key == _ctx.selected?.key && _ctx.period == 1),
                                    'bg-royal-blue-300 cursor-not-allowed': _ctx.subscription.key == _ctx.selected?.key && _ctx.period == 1
                                })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('subscription.choose_and_pay')), 1)
                ]),
                _: 1
              }, 8, ["to", "disabled", "class"])
            ])
          ])
        ])
      ]),
      _createVNode(_component_CardListComponent),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_SwitchGroup, {
          as: "div",
          class: "px-4 py-5 sm:p-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SwitchLabel, {
              as: "h3",
              class: "text-base font-semibold text-gray-900",
              passive: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('subscription.auto_renew')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_SwitchDescription, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('subscription.auto_renew_tip')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_Switch, {
                  modelValue: _ctx.renewEnabled,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.renewEnabled) = $event)),
                  class: _normalizeClass([_ctx.renewEnabled ? 'bg-royal-blue-500' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-700 focus:ring-offset-2 focus:outline-hidden'])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: _normalizeClass([_ctx.renewEnabled ? 'translate-x-5' : 'translate-x-0', 'inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}